module.exports = "/_next/static/images/FreePlan-sm-8b90e21e75763ee1c861a0e4f098a630.webp";